import { Link } from "react-router-dom";

const STAPPEN = [
  { num: 1, emoji: "👤", title: "Vul een profiel in", desc: "Naam, leeftijd, relatie, 2 interesses en een life event. Duurt minder dan 2 minuten." },
  { num: 2, emoji: "🤖", title: "Givn denkt mee", desc: "Op basis van het profiel selecteert Givn 5 cadeausuggesties die écht passen — geen generieke lijsten." },
  { num: 3, emoji: "📬", title: "Ontvang suggesties per mail", desc: "De suggesties landen in je inbox met directe links naar de webshop. Klaar om te bestellen." },
  { num: 4, emoji: "📅", title: "Klik op je agenda knop", desc: "Google Calendar, Apple Agenda of Outlook — kies er één. Het event staat er direct in." },
  { num: 5, emoji: "⏰", title: "Herinnering vóór het event", desc: "14 dagen van tevoren krijg je een melding. Met daarin de productlinks, zodat je direct kunt bestellen." },
  { num: 6, emoji: "🎁", title: "Perfecte cadeau, zonder stress", desc: "Geen last-minute gedoe meer. Jij geeft het beste cadeau, op tijd, altijd." },
];

const FAQS = [
  { q: "Kost Givn iets?", a: "Nee — Givn is volledig gratis. We verdienen een kleine commissie als je via onze links iets bestelt, zonder dat jij meer betaalt." },
  { q: "Hoe persoonlijk zijn de suggesties?", a: "Givn combineert interesses, leeftijd, relatie en eventuele life events tot een unieke selectie. Geen algoritme dat iedereen hetzelfde aanbiedt." },
  { q: "Werkt de agenda herinnering met mijn app?", a: "Ja. Google Calendar werkt via een directe link, Outlook ook. Voor Apple Agenda open je de meegestuurde .ics bijlage — die opent automatisch in je Agenda app." },
  { q: "Kan ik meerdere mensen toevoegen?", a: "Ja, je kunt zo vaak als je wilt een nieuw profiel invullen. Elke persoon krijgt zijn eigen suggesties en agenda herinnering." },
  { q: "Worden mijn gegevens opgeslagen?", a: "Alleen je e-mailadres wordt bewaard om je te kunnen mailen. We delen nooit gegevens met derden. Bekijk ons privacybeleid voor details." },
  { q: "Ik heb een vraag of suggestie.", a: "Stuur een mail naar hallo@givn.to — we lezen alles en reageren altijd." },
];

export default function HoeHetWerkt() {
  return (
    <main className="main">
      <div className="page-hero fi">
        <div className="hero-tag">Hoe het werkt</div>
        <h1>Van profiel naar <em>perfect cadeau</em><br/>in 6 stappen</h1>
        <p>Givn werkt als een slim cadeaubrein dat jou nooit meer laat stressen over wat je moet geven.</p>
      </div>

      <div className="steps-grid">
        {STAPPEN.map((s, i) => (
          <div key={s.num} className="step-card" style={{ animationDelay: `${i * 0.1}s` }}>
            <div className="step-num">{s.num}</div>
            <div className="step-emoji">{s.emoji}</div>
            <div className="step-title">{s.title}</div>
            <div className="step-desc">{s.desc}</div>
          </div>
        ))}
      </div>

      <div className="faq-section">
        <div className="faq-title">Veelgestelde vragen</div>
        {FAQS.map((f, i) => (
          <div key={i} className="faq-item fi" style={{ animationDelay: `${i * 0.07}s` }}>
            <div className="faq-q">{f.q}</div>
            <div className="faq-a">{f.a}</div>
          </div>
        ))}
      </div>

      <div className="contact-box fi">
        <h2>Klaar om te beginnen?</h2>
        <p>Vul je eerste profiel in — het duurt 2 minuten en je krijgt direct suggesties op maat.</p>
        <Link to="/">Start de cadeauassistent →</Link>
      </div>
    </main>
  );
}
